import { StatsigClient } from '@statsig/react-bindings';

export const getStatsigGateValue = (gateName: string): boolean => {
  return StatsigClient.instance().checkGate(gateName);
};

export const getStatsigLoadingStatus = (): boolean => {
  return StatsigClient.instance().loadingStatus === 'Loading';
};
